import { useForm, UseFormProps, FormProvider, useWatch } from 'react-hook-form';
import { FormLabelErrorMessage } from '@/components/forms';
import FormSearchUserFooter from './FormSearchUserFooter';
import FormSearchUserHeader from './FormSearchUserHeader';
import FormSearchUserBody from './FormSearchUserBody';
import { DEFAULT_FORM_CONFIG } from '@/constants';
import { ISearchUserData } from '@/lib/interface';
import { ReactNode } from 'react';
import { TFormData } from '.';

type TProps = {
  callback: (user: ISearchUserData) => Promise<void>;
  submitButtonTitle?: string;
  description?: ReactNode;
  title?: string;
};

const VARIABLES = {
  formConfig: {
    ...DEFAULT_FORM_CONFIG
  } as UseFormProps<TFormData>
};

const FormSearchUser = ({
  callback,
  description,
  submitButtonTitle = 'Rechercher',
  title = 'Rechercher'
}: TProps) => {

  const formMethods = useForm<TFormData>(VARIABLES.formConfig);
  const errorMessage = useWatch({ control: formMethods.control, name: 'errorMessage' });

  return (
    <FormProvider {...formMethods}>
      <FormSearchUserHeader
        title={title}
        description={description} />
      <FormSearchUserBody />
      <FormLabelErrorMessage errorMessage={errorMessage} />
      <FormSearchUserFooter
        submitButtonTitle={submitButtonTitle}
        callback={callback} />
    </FormProvider>
  );

};

export default FormSearchUser;
